import isBetweenTwoTextBlocks from './isBetweenTwoTextBlocks/isBetweenTwoTextBlocks';
import isLastIndexOfArray from './isLastIndexOfArray/isLastIndexOfArray';
import getConfig from './getConfig/getConfig';
import getWordCountFromCurrentIdxToEnd from './getWordCountFromCurrentIdxToEnd/getWordCountFromCurrentIdxToEnd';
import getWordCountFromLastIndexOfTypeToEndOfArray from './getWordCountFromLastIndexOfTypeToEndOfArray/getWordCountFromLastIndexOfTypeToEndOfArray';
import hasRuleBeenInjected from './hasRuleBeenInjected/hasRuleBeenInjected';
import isConfigValid from './isConfigValid/isConfigValid';
import isRightNumberOfWordsForTeads from './isRightNumberOfWordsForTeads/isRightNumberOfWordsForTeads';
import digiteka from './shouldInjectDigiteka/shouldInjectDigiteka';
import shouldInjectFinalSideAd from './shouldInjectFinalSideAd/shouldInjectFinalSideAd';
import shouldInjectFirstSideAd from './shouldInjectFirstSideAd/shouldInjectFirstSideAd';
import shouldInjectLastAd from './shouldInjectLastAd/shouldInjectLastAd';
import shouldInjectListArticleInlineAds from './shouldInjectListArticleInlineAds/shouldInjectListArticleInlineAds';
import shouldInjectGalleryInlineAds from './shouldInjectGalleryInlineAds/shouldInjectGalleryInlineAds';
import shouldInjectInlineAndSideAds from './shouldInjectInlineAndSideAds/shouldInjectInlineAndSideAds';
import shouldInjectSubscriptionAndNewsletter from './shouldInjectSubscriptionAndNewsletter/shouldInjectSubscriptionAndNewsletter';
import shouldInjectSubscriptionOrNewsletter from './shouldInjectSubscriptionOrNewsletter/shouldInjectSubscriptionOrNewsletter';

export default {
  isBetweenTwoTextBlocks,
  isLastIndexOfArray,
  getConfig,
  getWordCountFromCurrentIdxToEnd,
  getWordCountFromLastIndexOfTypeToEndOfArray,
  hasRuleBeenInjected,
  isConfigValid,
  isRightNumberOfWordsForTeads,
  ...digiteka,
  shouldInjectFinalSideAd,
  shouldInjectFirstSideAd,
  shouldInjectLastAd,
  shouldInjectListArticleInlineAds,
  shouldInjectGalleryInlineAds,
  shouldInjectInlineAndSideAds,
  shouldInjectSubscriptionAndNewsletter,
  shouldInjectSubscriptionOrNewsletter,
};
